<template>
	<table class="app-card-table">
		<thead>
			<slot name="header" />
		</thead>
		<slot name="body" />
	</table>
</template>

<style lang="scss">
.app-card-table {
	border-collapse: collapse;
	min-width: 100%;

	.app-card-title {
		padding: 10px 12px;
		text-align: left;
	}

	th,
	td {
		padding: 0;
		height: 100%;

		&:not(:first-child) {
			border-left: 1px solid var(--border);
		}

		&.numeric {
			text-align: end;

			.table-cell-flex {
				align-items: unset;
			}
		}

		.table-cell-flex {
			display: flex;
			flex-direction: column;
			padding: 8px;
			flex: 1;

			&.numeric {
				align-items: flex-end;
			}
		}

		.column-name {
			font-size: 0.85rem;
			font-weight: 600;
		}

		.column-value {
			font-size: 0.85rem;
		}
	}

	th.column-value {
		font-weight: 600;
	}

	thead,
	tr {
		border-bottom: 1px solid var(--border);
	}

	tr:last-child,
	> thead:last-child {
		border: none;
	}

	> tr:last-child {
		border-radius: 0 0 var(--border-radius) var(--border-radius);
	}
}

.app-card.no-border .app-card-table {
	> tr:last-child,
	> thead:last-child {
		border-bottom: 1px solid var(--border);
	}
}
</style>
